import { useHttpMethods } from "./useHttpMethods";

export const useApi = () => {
  const { get, put, post } = useHttpMethods();

  const signUp = (data) => post("/auth/signup", data, { sendToken: false });
  const login = (data) => post("/auth/login", data, { sendToken: false });
  const logout = () => post("/auth/logout");

  const getMyMeetings = (params) => get("/lw", { query: params });
  const getMeetingDetails = (lwid) => get(`/lw/${lwid}`);

  const createMeeting = (data) => post("/lw", data);
  const updateMeeting = (lwid, data) => put(`/lw/${lwid}`, data);
  const endMeeting = (lwid) => post(`/lw/${lwid}/end`);

  const getAllMeetingParticipants = (lwid) => get(`/lw/${lwid}/participants`);

  const inviteParticipant = (lwid, { email, uid }) => post(`/lw/${lwid}/participants/invite`, { email, uid });
  const uninviteParticipant = (lwid, pid) => post(`/lw/${lwid}/participants/${pid}/uninvite`);

  const joinMeeting = (lwid) => post(`/lw/${lwid}/join`);
  const leaveMeeting = (lwid) => post(`/lw/${lwid}/leave`);

  const muteAudio = (lwid) => post(`/lw/${lwid}/audio/mute`);
  const unmuteAudio = (lwid) => post(`/lw/${lwid}/audio/unmute`);
  const muteVideo = (lwid) => post(`/lw/${lwid}/video/mute`);
  const unmuteVideo = (lwid) => post(`/lw/${lwid}/video/unmute`);

  const screenIOAction = (lwid, data) => post(`/lw/${lwid}/io`, data);

  const loadCourses = () => get("/course");
  const createCourse = (name) => post("/course", { name });

  const loadOrgUsers = () => get("/org/users");

  // TODO: debug menu API methods

  const sendCurrentUserEvent = ({ lwid, pid, data }) => put(`/admin/lw/${lwid}/participants/${pid}`, data);

  // const helpers = () =>
  // const fetchMeetingParticipants = async (meetingId) => getAllMeetingParticipants(meetingId).then((res) => res);
  //
  // const sortParticipantsWithCurrentUserFirst = (participants, userId) => {
  //   const others = participants.filter((participant) => participant.uid !== userId);
  //   const currentUser = participants.find((participant) => participant.uid === userId);
  //   return [currentUser, ...others];
  // };
  //
  // const getMuteState = (muteStatus) => ({
  //   local: muteStatus === "mute",
  //   stream: muteStatus === "mute",
  // });

  // const updateMeetingState = (_SET_MEETING_STATE, meetingId, currentUser, allParticipants) => {
  //   if (!_SET_MEETING_STATE) {
  //     console.error("context_handler is absent setMeetingParticipantsHelper()");
  //     return;
  //   }
  //   _SET_MEETING_STATE((prevState) => ({
  //     ...prevState,
  //     activeMeetingId: meetingId,
  //     currentUser: {
  //       ...prevState.currentUser,
  //       ...currentUser,
  //       isAudioMuted: getMuteState(currentUser.audio_mute),
  //       isVideoMuted: getMuteState(currentUser.video_mute),
  //     },
  //     users: {
  //       all: allParticipants,
  //       active: allParticipants.filter((participant) => participant.status !== "removed" && !participant.status.includes("not")),
  //     },
  //   }));
  // };

  // const getAllMeetingParticipantsAndSetToContextHelper = async (meetingId, _SET_MEETING_STATE) => {
  //   const userData = {}; // TODO: temp update.
  //   const participants = await fetchMeetingParticipants(meetingId);
  //   const sortedParticipants = sortParticipantsWithCurrentUserFirst(participants.participant_details, userData.userId);
  //
  //   console.log("currentUser to set: ", sortedParticipants[0]);
  //   updateMeetingState(_SET_MEETING_STATE, meetingId, sortedParticipants[0], participants.participant_details);
  //
  //   localStorage.setItem("join_status", sortedParticipants[0].status);
  //   if (!sortedParticipants[0].status.includes("not")) localStorage.setItem("joined_meetingId", meetingId);
  //
  //   return sortedParticipants;
  // };

  // const getCurrentUserFromParticipantsListHelper = async (meetingId, userId) => {
  //   const result = await getAllMeetingParticipants(meetingId).then((res) => res.participant_details);
  //   return result.find((participant) => participant.uid === userId).pid;
  // };

  // const prepareScreensHelper = (meetingId, meetingsRes, _SET_SCREEN_STATE, _SET_MEETING_STATE) => {
  //   if (meetingId) {
  //     const meeting = meetingsRes.meeting_details.find((meetingData) => meetingData.mid === +meetingId);
  //     if (meeting) {
  //       const { screens } = meeting.j;
  //       const { created_by } = meeting;
  //       if (screens.filter((screen) => screen.id > 0)[0]?.os_icon_file_name)
  //         _SET_SCREEN_STATE((prevState) => {
  //           const firstScreenId = screens.find((screen) => screen.id > 0)?.id;
  //           return {
  //             ...prevState,
  //             created_by,
  //             screens,
  //             currentScreen: {
  //               ...prevState.currentScreen,
  //               id: prevState.currentScreen.id || firstScreenId,
  //             },
  //           };
  //         });
  //
  //       _SET_MEETING_STATE &&
  //         _SET_MEETING_STATE((prevState) => ({
  //           ...prevState,
  //           created_by,
  //         }));
  //     }
  //   }
  // };

  // ({
  // getAllMeetingParticipantsAndSetToContextHelper,
  // getCurrentUserFromParticipantsListHelper,
  // prepareScreensHelper,
  // });
  return {
    signUp,
    login,
    logout,

    getMyMeetings,
    getMeetingDetails,

    createMeeting,
    updateMeeting,
    endMeeting,

    getAllMeetingParticipants,

    inviteParticipant,
    uninviteParticipant,

    joinMeeting,
    leaveMeeting,

    muteAudio,
    unmuteAudio,
    muteVideo,
    unmuteVideo,

    screenIOAction,

    loadCourses,
    createCourse,

    loadOrgUsers,

    // debug menu methods

    sendCurrentUserEvent,

    // helpers,
  };
};
